import type { CityConfig } from "../city-template/types";

export const westWarwickConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "West Warwick",
  state: "Rhode Island",
  stateAbbr: "RI",
  slug: "west-warwick",
  route: "/west-warwick",
  title: "Emergency Passport West Warwick, RI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in West Warwick, RI — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving West Warwick, Arctic, Crompton, and all Kent County. Skip the 8-11 week wait at the post office.",
  h1: "Emergency & Expedited Passport Services in West Warwick, RI",
  heroSubtitle: "Historic mill town passport that needs renewal before your Ireland heritage trip? Pawtuxet Valley family booking a last-minute Caribbean cruise? Arctic resident heading to Canada for a business conference? We help West Warwick residents — from the mill district families to Crompton commuters to the Arctic neighborhood — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Historic%20brick%20mill%20buildings%20along%20the%20Pawtuxet%20River%20in%20West%20Warwick%20Rhode%20Island%20at%20golden%20hour%2C%20restored%20industrial%20architecture%20with%20warm%20amber%20light%20reflecting%20off%20the%20water%2C%20classic%20New%20England%20mill%20town%20charm%20with%20tree-lined%20riverbanks%2C%20elevated%20photography%20with%20rich%20autumn%20tones%20and%20dramatic%20sky%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=west-warwick-hero-2026&orientation=landscape",
  heroImageAlt: "West Warwick Rhode Island historic mill buildings along the Pawtuxet River at golden hour",
  geoPosition: "41.6969;-71.5164",
  geoPlacename: "West Warwick, Rhode Island",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St, Boston, MA 02222",
    distance: "Located in downtown Boston — approximately 55 miles from West Warwick, appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "West Warwick", zips: "02893" },
    { name: "Coventry", zips: "02816, 02827" },
    { name: "Warwick", zips: "02886, 02887, 02888, 02889, 02818" },
    { name: "Cranston", zips: "02905, 02906, 02907, 02910, 02920, 02921" },
    { name: "Providence", zips: "02901–02912, 02918, 02940" },
    { name: "East Greenwich", zips: "02818" },
    { name: "North Kingstown", zips: "02852, 02874" },
    { name: "South Kingstown", zips: "02879, 02881, 02883" },
    { name: "Narragansett", zips: "02882" },
    { name: "Exeter", zips: "02822, 02828, 02875" },
    { name: "Johnston", zips: "02919" },
    { name: "Pawtucket", zips: "02860, 02861, 02862" },
    { name: "East Providence", zips: "02914, 02915, 02916" },
    { name: "North Providence", zips: "02904, 02911" },
    { name: "Woonsocket", zips: "02895" },
    { name: "Cumberland", zips: "02864, 02827" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour West Warwick Emergency Processing", desc: "Reserved courier access to the Boston Passport Agency — as fast as 24 hours for West Warwick travelers with immediate departures." },
    { icon: "ri-building-2-line", title: "Mill Town Family Expedited", desc: "Generations of West Warwick families — from the Arctic neighborhood to Crompton — trust us for first-time passports, renewals, and child passports. We know Kent County." },
    { icon: "ri-ship-line", title: "Cruise & Caribbean Ready", desc: "West Warwick families love last-minute cruise deals and all-inclusive resort packages. We handle the passport while you handle the packing." },
    { icon: "ri-map-pin-line", title: "Serving the Pawtuxet Valley", desc: "From Arctic to Crompton, Lippitt to Phenix — we serve every West Warwick neighborhood with the same fast, reliable courier processing." },
  ],
  internalLinks: [
    { name: "Fast passport services in Providence, RI", route: "/providence" },
    { name: "Expedited passport in Warwick, RI", route: "/warwick" },
    { name: "Quick passport services in Cranston, RI", route: "/cranston" },
    { name: "Urgent passport services in Coventry, RI", route: "/coventry" },
    { name: "Rhode Island passport services overview", route: "/states/rhode-island" },
  ],
  fpcOfficeAddress: "One Boston Place, Suite 2600, Boston, MA 02108",
  fpcOfficeNote: "Fast Passport Center serves West Warwick via secure registered courier with direct access to the Boston Passport Agency at 10 Causeway St. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. West Warwick residents can ship from any UPS Store, FedEx Office, or post office location across Kent County.",
  fpcOfficeDistance: "Serving West Warwick, Coventry, Warwick, Cranston, and all Kent County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout West Warwick and the greater Pawtuxet Valley region. From the Arctic village center to Crompton's riverside neighborhoods, from Lippitt to Phenix — we serve every West Warwick neighborhood and all of Kent County. Our courier service eliminates the need to drive to Boston and wait for a passport agency appointment.",
  nearbyCitiesIntro: "We serve West Warwick and all surrounding Kent County communities including Coventry, Warwick, East Greenwich, and Cranston. We also serve travelers departing from T.F. Green Airport and Logan International who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in West Warwick as simple as possible — with the efficiency and reliability Kent County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most West Warwick travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "West Warwick travelers encounter unique passport issues — everything from cruise bookings with short lead times to heritage trips requiring first-time passports for extended family members. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "West Warwick travelers — from mill district families to Arctic neighborhood residents to Crompton commuters — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in West Warwick, RI? Here are the most common ones we hear from Kent County travelers.",
  statePageRoute: "/states/rhode-island",
  statePageName: "Rhode Island",
  servicesIntro: "Whether you need a renewal before a Logan flight to Dublin, an emergency passport for a last-minute cruise from Miami, or a first-time passport for a Pawtuxet Valley family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ri.gov",
  dmvLabel: "Rhode Island DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Logan flight to Dublin in two days? Last-minute cruise departure from Miami this weekend? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for West Warwick-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help West Warwick residents renew fast — no agency visit required for most renewals. Perfect for Kent County families and Pawtuxet Valley commuters preparing for international travel.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide West Warwick residents through every step — from Arctic to Crompton to Lippitt — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your Pawtuxet Valley family trip or Kent County business travel is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your West Warwick family vacation or spring break cruise stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for West Warwick residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for West Warwick business travelers and Pawtuxet Valley professionals who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide West Warwick-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport West Warwick RI", description: "Urgent passport processing for West Warwick Rhode Island travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal West Warwick RI", description: "Fast passport renewal for West Warwick Rhode Island residents with a previously-issued passport." },
    { name: "First-Time Passport West Warwick RI", description: "New passport application services for West Warwick Rhode Island residents applying for their first passport." },
    { name: "Child Passport West Warwick RI", description: "Minor passport services for West Warwick Rhode Island families with children under 16." },
    { name: "Name Change Passport West Warwick RI", description: "Passport name correction after marriage, divorce, or legal name changes for West Warwick residents." },
    { name: "Second Passport West Warwick RI", description: "Second passport services for West Warwick business travelers and frequent international flyers." },
  ],
  testimonials: [
    {
      name: "Daniel S.",
      location: "West Warwick, RI",
      rating: 5,
      text: "I needed an emergency passport from West Warwick for a family emergency abroad. Fast Passport Center got it done in 3 days. The agent stayed in touch every step of the way — I never had to wonder what was happening.",
      service: "Emergency Passport",
    },
    {
      name: "Amy C.",
      location: "Arctic, West Warwick, RI",
      rating: 5,
      text: "Renewed my expired passport through Fast Passport Center for a heritage trip to Ireland. Chose the 5-day option and had it back in 4. They caught a photo issue at CVS before it became a rejection.",
      service: "Passport Renewal",
    },
    {
      name: "The Oliveira Family",
      location: "Crompton, West Warwick, RI",
      rating: 5,
      text: "We booked a last-minute cruise to the Bahamas and realized our daughter had never had a passport. Fast Passport Center walked us through the child passport process and it arrived in 5 days. Incredible service for Kent County families.",
      service: "Child Passport",
    },
    {
      name: "Robert W.",
      location: "Lippitt, West Warwick, RI",
      rating: 5,
      text: "Second time using Fast Passport Center. I travel to Canada regularly for work and needed a second passport while my primary was in visa processing. They got it done in 4 days. Won't use anyone else in Rhode Island.",
      service: "Second Passport",
    },
  ],
  facilities: [
    {
      id: "ww-1",
      name: "West Warwick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1155 Main St",
      city: "West Warwick",
      state: "RI",
      zip: "02893",
      phone: "(401) 821-6171",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Central West Warwick",
      website: "https://tools.usps.com/find-location.htm?location=1378641",
      websiteLabel: "USPS Location",
      notes: "Main West Warwick post office serving the entire town. Passport acceptance services by appointment. First-time applicants and child applications require in-person visit here.",
      icon: "ri-mail-line",
    },
    {
      id: "ww-2",
      name: "Coventry Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1600 Nooseneck Hill Rd",
      city: "Coventry",
      state: "RI",
      zip: "02816",
      phone: "(401) 397-4420",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Coventry — ~5 miles from West Warwick",
      website: "https://tools.usps.com/find-location.htm?location=1378615",
      websiteLabel: "USPS Location",
      notes: "Nearby alternative for West Warwick residents in the western part of town. Passport acceptance services by appointment. Photo services available.",
      icon: "ri-mail-line",
    },
    {
      id: "ww-3",
      name: "Warwick Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "575 Sandy Ln",
      city: "Warwick",
      state: "RI",
      zip: "02889",
      phone: "(401) 737-8700",
      hours: "Mon–Fri 8:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Warwick — ~6 miles from West Warwick",
      website: "https://tools.usps.com/find-location.htm?location=1378552",
      websiteLabel: "USPS Location",
      notes: "Convenient for West Warwick residents near the Warwick border. Near T.F. Green Airport. Passport photos available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "ww-4",
      name: "RI DMV — Cranston",
      type: "State DMV / ID Services",
      address: "600 New London Ave",
      city: "Cranston",
      state: "RI",
      zip: "02920",
      phone: "(401) 462-4368",
      hours: "Mon–Fri 8:30 AM – 3:15 PM",
      distance: "Cranston — ~10 miles from West Warwick",
      website: "https://dmv.ri.gov",
      websiteLabel: "RI DMV Website",
      notes: "Main Rhode Island DMV office for driver licenses and REAL ID — important for passport applications requiring valid government photo ID. Appointment strongly recommended.",
      icon: "ri-car-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Boston Passport Agency (55+ miles from West Warwick)", fpc: "Most West Warwick travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Kent County Guidance", agency: "Generic — no Pawtuxet Valley, cruise, or mill town family expertise", fpc: "Full West Warwick/Kent County family and cruise knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming the Boston Agency Takes Walk-Ins From West Warwick",
      description: "The Boston Passport Agency requires appointments even for emergencies. Many West Warwick residents drive 55 miles to Boston only to be turned away. Our courier channel bypasses this entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "West Warwick applicants often attempt the simpler renewal form when their passport was issued at age 15 or younger — especially for multi-generational family trips. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations at Local Pharmacies",
      description: "Many CVS and Walgreens locations in the West Warwick-Coventry area produce photos that fail State Department standards — wrong head size, shadows, or off-white backgrounds. We catch this in review.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Family Cruises",
      description: "West Warwick families booking cruises frequently overlook the DS-3053 consent form when one parent is handling the booking. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for the 6-Month Passport Validity Rule",
      description: "West Warwick travelers booking to Ireland, Italy, or other European destinations often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or office in West Warwick." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most West Warwick clients ship from home or the UPS Store on Washington Street — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive to Boston or wait at the Boston Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty for your Pawtuxet Valley travel plans." },
  ],
  faqs: [
    { q: "How fast can I get a passport in West Warwick?", a: "We offer West Warwick-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in West Warwick?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (West Warwick Post Office or nearby Coventry/Warwick post offices), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your West Warwick address." },
    { q: "Where can I get passport acceptance in West Warwick?", a: "The West Warwick Post Office at 1155 Main Street is your primary acceptance facility. Nearby alternatives include the Coventry Post Office on Nooseneck Hill Road and the Warwick Post Office on Sandy Lane. We maintain an updated list with hours and appointment options." },
    { q: "Does the Boston Passport Agency handle walk-ins from West Warwick?", a: "The Boston Passport Agency requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without driving to Boston." },
    { q: "What is the best price for expedited passport service in West Warwick?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do West Warwick applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a West Warwick-specific checklist." },
    { q: "Can I get a passport photo in West Warwick?", a: "Yes — CVS Pharmacy, Walgreens, and UPS Store locations in West Warwick and nearby Coventry and Warwick offer passport photos. We recommend confirming standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my West Warwick passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from West Warwick to final return shipping typically matches your chosen speed tier." },
    { q: "Can you help with passport cards for cruise travel from West Warwick?", a: "Absolutely. The passport card is ideal for West Warwick families taking closed-loop cruises to the Caribbean or Bahamas. It is a wallet-size, lower-cost alternative to the passport book for sea travel. We expedite passport cards with the same courier service." },
    { q: "Is West Warwick near a passport agency?", a: "The nearest passport agency is in Boston — approximately 55 miles from West Warwick. However, it only serves travelers with life-or-death emergencies. For standard expedited needs — even urgent ones — our courier channel is faster and more accessible than driving to Boston." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for West Warwick Residents",
    intro: "West Warwick's position in the heart of Kent County — with easy access to T.F. Green Airport and a strong working-class travel culture — creates distinct passport timing challenges. Here's what West Warwick travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "PVD — T.F. Green Airport (Warwick)",
        subtitle: "Just 10 minutes from West Warwick",
        description: "T.F. Green is practically in West Warwick's backyard — a short drive down Route 2 or Route 117. The airport serves domestic routes plus limited international connections. Many West Warwick families use PVD for domestic flights to international gateways like JFK, Newark, or Philadelphia for connecting to final destinations.",
        tip: "Even if you are connecting through another U.S. hub to fly internationally, you still need a valid passport at T.F. Green. We have seen West Warwick travelers turned away at check-in because their passport was expired.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "BOS — Logan International Airport",
        subtitle: "Boston Logan, ~55 miles — the international gateway",
        description: "Logan is where West Warwick travelers go for direct international flights — Dublin, London, Paris, Lisbon. The drive up I-95 takes about an hour without traffic. Logan's global reach, combined with Rhode Island's strong Irish, Italian, and Portuguese heritage, creates a steady stream of family heritage trips and passport urgencies.",
        tip: "West Warwick-to-Boston is manageable until there's a Friday afternoon backup on I-95 — and there's always a Friday afternoon backup. Factor in drive time when calculating your passport appointment window.",
      },
      {
        icon: "ri-ship-line",
        title: "Cruise Travel & Caribbean Getaways",
        subtitle: "West Warwick families love cruises and all-inclusives",
        description: "West Warwick has one of the highest rates of cruise travel per capita in Kent County. Families book last-minute cruise deals from Miami, Fort Lauderdale, and Port Canaveral — plus all-inclusive resort packages to the Dominican Republic, Cancun, and Jamaica. These bookings often have 3–4 week lead times, which is too short for standard post office processing.",
        tip: "Closed-loop cruises (starting and ending at the same U.S. port) can use a passport card instead of a book — a lower-cost option that we can expedite just as fast.",
      },
      {
        icon: "ri-globe-line",
        title: "Heritage Travel & Multi-Generational Trips",
        subtitle: "Irish, Italian, and Portuguese roots run deep in the Pawtuxet Valley",
        description: "West Warwick's strong ethnic communities — particularly Irish, Italian, and Portuguese families — drive significant heritage travel. Multi-generational trips to the Azores, family reunions in County Cork, and first-time passport applications for teenagers heading to Italy with grandparents are extremely common. These trips often involve 3+ family members needing passports simultaneously.",
        tip: "Multi-generational trips often mean mixed application types — some renewals, some first-time, some child passports. We handle the entire family's paperwork in one coordinated submission.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The Pawtuxet Valley Travel Culture",
      description: "West Warwick may be a small town, but its residents travel big. The combination of strong immigrant heritage, a cruise-loving culture, and proximity to two international airports means West Warwick punches above its weight in passport demand. We have helped families in the Arctic neighborhood get five passports simultaneously for a multi-generational trip to the Azores — all delivered in under a week.",
    },
  },
  destinations: {
    title: "Where West Warwick Travelers Go — And Why Passports Get Urgent",
    intro: "West Warwick's heritage communities and cruise culture create unique international travel patterns. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "35%", label: "of West Warwick expedited requests are cruise or all-inclusive resort-related with 3–4 week lead times" },
      { stat: "2–4 Weeks", label: "average lead time West Warwick travelers have from booking to international departure" },
      { stat: "Nov–Mar", label: "peak season when winter Caribbean cruises and holiday heritage trips collide" },
      { stat: "48 Hours", label: "shortest turnaround we have accommodated for a West Warwick family departing on a Caribbean cruise" },
    ],
    destinations: [
      { name: "Ireland", context: "Strong Irish heritage across the Pawtuxet Valley — family reunions, heritage trips to Cork, Kerry, and Galway", urgency: "Heritage trips booked around St. Patrick's season and summer family reunions", icon: "ri-map-pin-2-line" },
      { name: "Portugal & the Azores", context: "Large Portuguese community in West Warwick and Kent County — family visits to the Azores and mainland Portugal", urgency: "Festas do Espírito Santo and summer family visits drive June–August demand", icon: "ri-map-pin-2-line" },
      { name: "Italy", context: "Italian-American families from West Warwick visiting Rome, Naples, and Sicily — multi-generational heritage travel", urgency: "Summer heritage trips booked 3–6 weeks out during school breaks", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Bahamas", context: "Cruise departures from Miami, Port Canaveral, and Fort Lauderdale — plus Dominican Republic and Jamaica resort packages", urgency: "Last-minute cruise deals and all-inclusive packages booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Business travel to Toronto and Montreal, family trips to Quebec, and Maritime province vacations", urgency: "Cross-border business trips often booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "London business travel, English heritage trips, and connecting flights through Heathrow to Europe", urgency: "Business trips booked 2–3 weeks out with fixed meeting dates", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Rhode Island Service Areas",
    crossLinksDesc: "We serve travelers across the Ocean State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Warwick", route: "/warwick" },
      { name: "Coventry", route: "/coventry" },
      { name: "Cranston", route: "/cranston" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — West Warwick", address: "1237 Main St, West Warwick, RI 02893", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — West Warwick", address: "2200 Providence St, West Warwick, RI 02893", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Warwick", address: "300 Quaker Ln, Warwick, RI 02886", hours: "Mon–Fri 9 AM – 7 PM, Sat 10 AM – 4 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Coventry", address: "879 Tiogue Ave, Coventry, RI 02816", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Warwick", address: "250 E Ave, Warwick, RI 02886", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 10 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
  ],
  dmvLocations: [
    {
      name: "RI DMV — Cranston",
      address: "600 New London Ave, Cranston, RI 02920",
      hours: "Mon–Fri, 8:30 AM – 3:15 PM",
      note: "Main Rhode Island DMV office — driver licenses, REAL ID, vehicle registration. About 10 miles from West Warwick. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "AAA Warwick",
      address: "1276 Bald Hill Rd, Warwick, RI 02886",
      hours: "Mon–Fri, 9:00 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      note: "AAA members can access limited DMV services including license renewals and REAL ID. Convenient Warwick location near the mall.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PVD",
      name: "T.F. Green Airport",
      distance: "About 10 miles from West Warwick",
      address: "2000 Post Rd, Warwick, RI 02886",
      note: "Rhode Island's primary airport — a short drive from West Warwick via Route 2. Serves domestic destinations and limited international connections.",
      flightUrl: "https://www.pvdairport.com/",
      flightLabel: "T.F. Green Airport Website",
      featured: true,
    },
    {
      code: "BOS",
      name: "Logan International Airport",
      distance: "About 55 miles from West Warwick",
      address: "1 Harborside Dr, Boston, MA 02128",
      note: "Major international hub with direct flights to Europe, Asia, and worldwide destinations. West Warwick travelers primarily use Logan for international travel.",
      flightUrl: "https://www.massport.com/logan-airport",
      flightLabel: "Logan International Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the Rhode Island Department of Health. Online, mail, or in-person options available for Kent County residents including West Warwick.",
      url: "https://health.ri.gov/records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the RI Department of Health Vital Records. Required for estate and legal matters in Kent County.",
      url: "https://health.ri.gov/records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the West Warwick Town Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.westwarwickri.org/town-clerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Rhode Island Family Court. Required for name change passport corrections for Kent County residents.",
      url: "https://www.courts.ri.gov/family/",
    },
  ],
};

export default westWarwickConfig;